var map = {
	"./LV1.webp": "d098",
	"./LV2.webp": "2070",
	"./LV3.webp": "057b",
	"./LV4.webp": "a803",
	"./LV5.webp": "8062",
	"./LV6.webp": "628a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2535";